const ANY = 'ANY';
const ONLY_ONE = 'ONLY_ONE';
const EQUAL = 'EQUAL';
const LESS_OR_EQUAL = 'LESS_OR_EQUAL';

export default  {
  ANY,
  ONLY_ONE,
  EQUAL,
  LESS_OR_EQUAL
};



// WEBPACK FOOTER //
// ./frontend/react/stores/basket/quantity_rules_states.js